export interface OtpSend {
  sent: boolean;
  state: string;
}
